// Runtime configuration. In a browser the app talks to its own origin with a session cookie.
// A future native shell (like Leaflet's and Feed Me's) would serve the page from milkmaybe-app://
// and inject `window.__MILK__` with the server URL and a bearer token.

export interface NativeConfig {
  serverUrl: string;
  token: string | null;
  platform: 'macos' | 'ios';
  appVersion?: string;
}

declare global {
  interface Window {
    __MILK__?: NativeConfig;
    webkit?: { messageHandlers?: Record<string, { postMessage(msg: unknown): void }> };
  }
}

const native = typeof window !== 'undefined' ? window.__MILK__ : undefined;

export const isNative = !!native;
export const platform: 'web' | 'macos' | 'ios' = native?.platform ?? 'web';

let serverUrl = (native?.serverUrl ?? '').replace(/\/$/, '');
let token: string | null = native?.token ?? null;

export const apiBase = () => serverUrl;
export const authToken = () => token;
export function setAuthToken(t: string | null) { token = t; }

/** Origin for links people share: the server in a native app, this site in a browser. */
export function webOrigin(): string {
  return serverUrl || window.location.origin;
}

// ---- small per-device preferences (localStorage can be blocked: never let that break the app)

export function pref<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(`milk.${key}`);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch { return fallback; }
}
export function setPref(key: string, value: unknown) {
  try { localStorage.setItem(`milk.${key}`, JSON.stringify(value)); } catch { /* storage blocked */ }
}
